export default $wire => ({
    value: $wire.entangle('value').live,
    emitEvent: $wire.get('emitEvent') || null,
    listenForEvent: $wire.get('listenForEvent') || null,

    init() {
        const self = this;
        if (this.listenForEvent) {
            window.addEventListener(self.listenForEvent, event => {
                self.value = Array.isArray(event.detail) ? event.detail[0] : event.detail;
                $wire.onChange();
            });
        }

        if (this.emitEvent) {
            window.dispatchEvent(new CustomEvent(self.emitEvent, { detail: self.value }));
            self.$watch('value', newValue => {
                window.dispatchEvent(new CustomEvent(self.emitEvent, { detail: newValue }));
            });
        }
    },

    isChecked(optionValue) {
        if (typeof this.value == 'boolean') {
            return this.value;
        }

        return this.value?.includes(optionValue);
    },
});
